import PropTypes from 'prop-types'
import Sort from './Sort'

function BlogHeader({ items, resultsTotal, isFiltered, filters, handleFilter, handleReset }) {
  return (
    <div
      className={`items-center justify-between md:flex ${
        resultsTotal === 0 ? 'invisible h-0 pointer-events-none' : ''
      }`}
    >
      <div className="flex flex-col font-normal lg:flex-row">
        <span>
          Showing {items.length.toString().padStart(2, '0')} of {resultsTotal.toString().padStart(2, '0')}
        </span>
        {isFiltered && (
          <div className="sm-down:mt-4 lg:ml-4">
            <button type="button" className="text-sm font-medium hover:underline text-brand-red" onClick={handleReset}>
              Clear
            </button>
          </div>
        )}
      </div>

      <div className={`items-center mt-6 md:flex md:mt-0 ${items.length < 2 ? 'hidden' : ''}`}>
        <div>
          <Sort name="sort" value={filters.sort} handleFilter={handleFilter} />
        </div>
      </div>
    </div>
  )
}

BlogHeader.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  resultsTotal: PropTypes.number,
  filters: PropTypes.object,
  handleFilter: PropTypes.func,
  isFiltered: PropTypes.bool,
  handleReset: PropTypes.func,
}

export default BlogHeader
